// extracted by mini-css-extract-plugin
export default {"otpBox":"BaPH4MoSh0Yuat3yAAw2","otpInput":"z4H9ZqFXeGTCA_Bop2uM","error":"baAmzW9yS98AgxRlXgZZ"};